import ApiClient from "../api";

const fetchData = async (endpoint: string, params: Record<string, string> = {}) => {
    try {
        const response = await ApiClient.get(endpoint, { params });
        return response;
    } catch (error) {
        console.error(`Error fetching ${endpoint}:`, error);
        throw error;
    }
};

export const getStates = () => fetchData("locations/states");

export const getCities = (selectedState: string) => fetchData("locations/cities", { state: selectedState });

export const getPincodes = (selectedCity: string) => fetchData("locations/pincodes", { city: selectedCity });
